import React from 'react';
import PropTypes from 'prop-types';
import { Portal } from '@edreamsodigeo/frontend-core';
import { PageContainer, MetaFlowProvider, FlightSummaryMeta, FlightSummaryActionsProvider, FlightSummaryMetaProvider } from '@edreamsodigeo/frontend-checkout';
import { PrimeDatalayerTracking } from '@edreamsodigeo/frontend-prime';
import MembershipProductEvaluation from '../../../../providers/MembershipProductEvaluationProvider';
import { flightSummaryActions } from '../../../../boundaries/checkoutFlightSummary';
import PrimeEventManagerProvider from '../../../../providers/PrimeEventManagerProvider';
import CheckoutFlightSummaryMetaPageTrackingProvider from './CheckoutFlightSummaryMetaPageTrackingProvider';
import { CheckoutFlightSummaryMetaPageTranslationsPageProvider } from './TranslationsPageProvider';
import { PrimeEqualProminenceMobileWrapper } from '../CheckoutFlightSummaryResults/PrimeEqualProminenceMobileWrapper';
import { PrimeDualPriceStickyBarMobileWrapper } from './PrimeDualPriceStickyBarMobileWrapper';
const FLIGHTS_FUNNEL = 'flights';
const CheckoutFlightSummaryMetaPageContent = () => {
  return /*#__PURE__*/React.createElement(MetaFlowProvider, {
    isMeta: true
  }, /*#__PURE__*/React.createElement(PrimeEventManagerProvider, null, /*#__PURE__*/React.createElement(MembershipProductEvaluation, {
    funnel: FLIGHTS_FUNNEL
  }, /*#__PURE__*/React.createElement(PrimeDatalayerTracking, null), /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(FlightSummaryMeta, {
    primeEqualProminenceMobile: /*#__PURE__*/React.createElement(PrimeEqualProminenceMobileWrapper, null)
  })))));
};
const CheckoutFlightSummaryMetaDualDisplayV2PageContent = () => {
  return /*#__PURE__*/React.createElement(MetaFlowProvider, {
    isMeta: true
  }, /*#__PURE__*/React.createElement(MembershipProductEvaluation, {
    funnel: FLIGHTS_FUNNEL
  }, /*#__PURE__*/React.createElement(PrimeDatalayerTracking, null), /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(FlightSummaryMeta, {
    primeEqualProminenceMobile: /*#__PURE__*/React.createElement(PrimeDualPriceStickyBarMobileWrapper, null)
  }))));
};
export const CheckoutFlightSummaryMetaPageComponent = () => /*#__PURE__*/React.createElement(Portal, {
  elementId: "checkout_flight_summary_meta_container",
  Component: CheckoutFlightSummaryMetaPageContent
});
export const CheckoutFlightSummaryMetaDualDisplayV2PageComponent = () => /*#__PURE__*/React.createElement(Portal, {
  elementId: "checkout_flight_summary_meta_dual_display_v2_container",
  Component: CheckoutFlightSummaryMetaDualDisplayV2PageContent
});
export const CheckoutFlightSummaryMetaPageProvider = ({
  children,
  onContinueWithFlight = flightSummaryActions.onContinueWithFlight
}) => {
  return /*#__PURE__*/React.createElement(CheckoutFlightSummaryMetaPageTranslationsPageProvider, null, /*#__PURE__*/React.createElement(CheckoutFlightSummaryMetaPageTrackingProvider, null, /*#__PURE__*/React.createElement(FlightSummaryActionsProvider, {
    onContinueWithFlight: onContinueWithFlight
  }, children)));
};
CheckoutFlightSummaryMetaPageProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onContinueWithFlight: PropTypes.func
};
const CheckoutFlightSummaryMetaPage = () => /*#__PURE__*/React.createElement(FlightSummaryMetaProvider, {
  regex: /.*checkout_flight_summary_meta\/(.*)/
}, /*#__PURE__*/React.createElement(CheckoutFlightSummaryMetaPageProvider, {
  onContinueWithFlight: flightSummaryActions.onContinueWithFlight
}, /*#__PURE__*/React.createElement(CheckoutFlightSummaryMetaPageComponent, null), /*#__PURE__*/React.createElement(CheckoutFlightSummaryMetaDualDisplayV2PageComponent, null)));
export default CheckoutFlightSummaryMetaPage;